import { ISportFeedResponse } from "@finbackoffice/websocket-client";
import classNames from "classnames";
import SportIcon from "components/base/sport-icon/SportIcon";
import { forwardRef, ForwardRefExoticComponent, RefAttributes } from "react";
import styles from "./advanced-sidebar-sport.module.sass";

type AdvancedSidebarSportProps = {
    sport: ISportFeedResponse;
    opened: boolean;
    isSelected?: boolean;
};

const AdvancedSidebarSport: ForwardRefExoticComponent<
    AdvancedSidebarSportProps & RefAttributes<HTMLDivElement>
> = forwardRef(({ sport, opened, isSelected }, ref) => (
    <div
        className={classNames(styles.sportsNavItem, {
            [styles.opened]: opened,
            [styles.selected]: isSelected,
        })}
        ref={ref}>
        <SportIcon sportId={sport.id} />
        <span className={styles.sportName}>{sport.name}</span>
        <span className={styles.gamesCount}>{sport.games_count}</span>
    </div>
));

export default AdvancedSidebarSport;
